import Preact, { Fragment } from "preact";
import { useState } from "preact/hooks";
import * as PropTypes from "prop-types";
import Widget from "./components/Widget/Widget";
import Modal from "./components/Modal";

export const App = ({
  quote,
  status,
  payer,
  mode,
  alignment = "right",
  variant = "default",
  logo,
  heading,
  subheading,
  primarycolor,
  secondarycolor,
  fontfamily,
}) => {
  const [routeModalOpen, setRouteModalOpen] = useState(false);
  let prevActiveElement;

  const modalHandler = () => {
    const event = new CustomEvent('route:modal:toggle');
    document.querySelector('route-protect-widget').dispatchEvent(event);
  };

  const closeModalHandler = () => {
    var body = document.querySelector('body');
    body.style.removeProperty('overflow');
    const routeModal = document.getElementsByClassName('route-modal')[0];

    if (routeModal) {
      routeModal.className = 'route-modal rm-close';
    }
    setRouteModalOpen(false);
    modalHandler();
    prevActiveElement && prevActiveElement.focus();
  }

  const openModalHandler = () => {
    var body = document.querySelector('body');
    body.style.overflow = 'hidden';
    const routeModal = document.getElementsByClassName('route-modal')[0];

    if (routeModal) {
      routeModal.className = 'route-modal rm-open';
    }

    setRouteModalOpen(true);
    modalHandler();
    prevActiveElement = document.activeElement;
    setTimeout(() => {
      if (routeModal && body) {
        body.prepend(routeModal);
      }
      document.getElementById('rm-modal-container') && document.getElementById('rm-modal-container').focus();
    }, 1)

  }

  return (
    <Fragment>
      <Widget
        payer={payer}
        quote={quote}
        status={status}
        mode={mode}
        alignment={alignment}
        onOpenModalClick={openModalHandler}
        variant={variant}
        logo={logo}
        heading={heading}
        subheading={subheading}
        primarycolor={primarycolor}
        secondarycolor={secondarycolor}
        fontfamily={fontfamily}
      />
      <Modal
        open={routeModalOpen}
        mode={mode}
        payer={payer}
        onCloseModalClick={closeModalHandler}
        primarycolor={primarycolor}
        secondarycolor={secondarycolor}
        variant={variant}
      />
    </Fragment>
  );
};

App.propTypes = {
  status: PropTypes.string,
  quote: PropTypes.string,
  payer: PropTypes.oneOf(["customer", "merchant"]),
  mode: PropTypes.oneOf(["light", "dark"]),
  alignment: PropTypes.oneOf(["left", "center", "right"]),
  children: PropTypes.node,
  variant: PropTypes.oneOf(["legacy", "default", "default-2", "green-pan", "fee"]),
  logo: PropTypes.string,
  heading: PropTypes.string,
  subheading: PropTypes.string,
  primarycolor: PropTypes.string,
  secondarycolor: PropTypes.string,
  fontfamily: PropTypes.string,
};

export default App;
